// import jwtDecode from 'jwt-decode'
import { computed, reactive } from 'vue';
import keycloakHandlerInstance from '../../security/keycloak';
import HTTP from '@/axios-auth';
import { KeycloakLoginOptions, KeycloakLogoutOptions } from 'keycloak-js';

// Helper function to safely parse storage values
const safeParseStorage = (key: string, storage: Storage): any => {
  const value = storage.getItem(key);
  return value ? JSON.parse(value) : null;
};

const state = reactive({
  acesso:
    safeParseStorage('acesso-cnh-social', window.localStorage) ||
    safeParseStorage('acesso-cnh-social', window.sessionStorage) ||
    null,
  usuario:
    safeParseStorage('usuario-cnh-social', window.localStorage) ||
    safeParseStorage('usuario-cnh-social', window.sessionStorage) ||
    null,
  persistCredentials: false,
  redirectTo: safeParseStorage('acesso-cnh-social-redirecto', window.localStorage) || null,
});

const getters = {
  acesso: computed(() => state.acesso),
  usuario: computed(() => state.usuario),
  persistCredentials: computed(() => state.persistCredentials),
  redirectTo: computed(() => state.redirectTo),
};

const actions = {
  setRedirectTo: (payload: string | null): void => {
    state.redirectTo = payload;
    if (payload) {
      window.localStorage.setItem('acesso-cnh-social-redirecto', JSON.stringify(state.redirectTo));
    } else {
      window.localStorage.removeItem('acesso-cnh-social-redirecto');
    }
  },

  setPersistCredentials: (persistCredentials: boolean): void => {
    state.persistCredentials = persistCredentials;
  },

  setAcesso: (payload: any): void => {
    state.acesso = payload;
    if (state.persistCredentials) {
      window.localStorage.setItem('acesso-cnh-social', JSON.stringify(state.acesso));
    } else {
      window.sessionStorage.setItem('acesso-cnh-social', JSON.stringify(state.acesso));
    }
  },

  clearAcesso: (): void => {
    state.acesso = null;
    state.usuario = null;

    window.localStorage.removeItem('acesso-cnh-social');
    window.sessionStorage.removeItem('acesso-cnh-social');

    window.localStorage.removeItem('usuario-cnh-social');
    window.sessionStorage.removeItem('usuario-cnh-social');
  },

  setUsuario: (payload: any): void => {
    state.usuario = payload;
    if (state.persistCredentials) {
      window.localStorage.setItem('usuario-cnh-social', JSON.stringify(state.usuario));
    } else {
      window.sessionStorage.setItem('usuario-cnh-social', JSON.stringify(state.usuario));
    }
  },

  login: async (optionsOrRedirect: KeycloakLoginOptions | string | null = null): Promise<any> => {
    // Suporte para o antigo padrão (string redirect)
    if (typeof optionsOrRedirect === 'string') {
       return keycloakHandlerInstance.login({
           redirectUri: optionsOrRedirect,
           idpHint: 'govbr' // Força govbr por padrão se usar string simples
       });
    }

    // Suporte para novas options
    if (typeof optionsOrRedirect === 'object' && optionsOrRedirect !== null) {
        return keycloakHandlerInstance.login(optionsOrRedirect);
    }

    // Fallback/comportamento antigo se nulo
    return keycloakHandlerInstance.login({ idpHint: 'govbr' }); 
  },


  logout: async (payload?: KeycloakLogoutOptions): Promise<void> => {
    actions.clearAcesso();
    await keycloakHandlerInstance.logout(payload);
  },

  loadUsuario: (payload: any) => {
    const config = {
      headers: {
        Authorization: `Bearer ${payload.access_token}`,
      },
    };
    return HTTP.get(process.env.VUE_APP_BASE_URL_API + '/user', config);
  },

  atualizarAcesso: async (): Promise<any> => {
    try {
      const acesso = state.acesso;
      let usuario;
      let loadUsuarioResponse;

      return Promise.resolve(usuario);
    } catch (error: any) {
      // console.log('expirou: ', error);
      if (error.response.status === 400 || error.response.status === 401) {
        error.response.status = 400;
        error.response.data.mensagem = 'Usuário ou senha inválidos';
      } else {
        error.response.status = 400;
        error.response.data.mensagem = 'Sua sessão expirou';
      }
      return Promise.reject(error);
    }
  },
};

export { state, getters, actions };
